import { ReportingServicePath } from "utils/constants";

export const reportsRequests = {
  executeReport: name => `${ReportingServicePath}reports/${name}`,
  sendMailAcademicDataReport: () => `${ReportingServicePath}reports/queue/all-students-academic-data`,
};
